import { FC, useEffect } from 'react';
import { Box, Button, styled } from '@mui/material';
import { useAppDispatch } from '@/store/hooks';
import { persistor } from '@/store/store';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/constants/routes';
import { clearStore } from '@/store/reducers/survey/surveySlice';
import analytics from '@/utils/analytics/analyticsInstance';

const NoData = styled(Box)(() => ({
  flex: 1,
  gap: 12,
  maxWidth: 600,
  flexDirection: 'column',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  alignSelf: 'center',
}));

const InvalidStep: FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleReset = () => {
    persistor.purge();
    dispatch(clearStore());
    navigate(ROUTES.SURVEY);
  };

  useEffect(() => {
    analytics.track('webOnboardingScreenOpened', {
      screen_title: 'Invalid step',
    });
  }, []);

  return (
    <NoData>
      Invalid step
      <Button onClick={handleReset} variant="outlined" size="large">
        Reset steps
      </Button>
    </NoData>
  );
};

export default InvalidStep;
